import clsx from 'clsx';

interface SectionTitleProps {
  title: string;
  accent?: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
}

export function SectionTitle({ title, accent, subtitle, action, className }: SectionTitleProps) {
  const parts = accent ? title.split(accent) : [title];

  return (
    <div className={clsx('mb-8 flex items-end justify-between gap-4', className)}>
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
          {accent && parts.length > 1 ? (
            <>
              {parts[0]}
              <span className="text-brand-600">{accent}</span>
              {parts.slice(1).join(accent)}
            </>
          ) : (
            title
          )}
        </h2>
        {subtitle && <p className="mt-2 max-w-2xl text-base text-slate-600">{subtitle}</p>}
        <div className="mt-3 h-0.5 w-12 rounded-full bg-brand-500" />
      </div>
      {action}
    </div>
  );
}
